export var hydro2 = {
  surface: {
    primary: '#FFFFFF',
    secondary: '#eef0f1',
    tertiary: '#002b45',
    main: '#FFFFFF',
    dark: '#eef0f1',
    inverted: '#002b45'
  },
  primary: {
    light: '#345370',
    main: '#002b45',
    dark: '#00001e'
  },
  secondary: {
    light: '#bbddf3',
    main: '#49a2df',
    dark: '#1874bc'
  },
  tertiary: {
    main: '#ED8800',
    //TODO: Added this to not reference the status.warning color for Button color
    dark: '#e16900'
  },
  status: {
    success: '#4caf50',
    successmuted: '#B8E0B9',
    warning: '#ED8800',
    warningmuted: '#FFD399',
    alert: '#be1e2d',
    alertmuted: '#F1A7AE'
  },
  text: {
    dark: {
      primary: '#4d4e4c',
      secondary: 'rgba(77,78,76,0.7)',
      disabled: 'rgba(77,78,76,0.3)'
    },
    primary: {
      primary: '#002b45',
      secondary: 'rgba(0,43,69,0.7)',
      disabled: 'rgba(0,43,69, 0.3)'
    },
    secondary: {
      primary: '#49a2df',
      secondary: 'rgba(73,162,223,0.7)',
      disabled: 'rgba(73,162,223,0.3)'
    },
    light: {
      primary: '#ffffff',
      secondary: 'rgba(255,255,255,0.7)',
      disabled: 'rgba(255,255,255,0.3)'
    }
  },
  divider: {
    light: 'rgba(255,255,255,0.16)',
    dark: 'rgba(77,78,76,0.16)'
  }
};
export default hydro2;